module.exports = __webpack_public_path__ + "static/labradorite-f657207c9522964a0b5b593d854c71fe.svg";